var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElementor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M256.061 0C114.676-.034.034 114.554 0 255.939S114.554 511.966 255.939 512 511.966 397.446 512 256.061V256C512 114.639 397.422.034 256.061 0z",
    opacity: 1,
    "data-original": "#ab003a",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff7ce8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.364 149.303h42.667v213.333h-42.667zM234.697 319.97h128v42.667h-128zM234.697 234.636h128v42.667h-128zM234.697 149.303h128v42.667h-128z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ff7ce8",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementor);
export default __webpack_public_path__ + "static/media/elementor.37be5375ede5a545c5e6b7c9f6896fdc.svg";
export { ForwardRef as ReactComponent };